/**
 * Time-of-day greeting for Remmi AI's welcome screen.
 *
 * "Good morning" before noon, "Good afternoon" until 6pm, "Good evening" after — based on the
 * user's local clock. Pure helper so it can be unit-tested and reused.
 */
export function getTimeOfDayGreeting(now: Date = new Date()): string {
  const hour = now.getHours();
  if (hour < 12) {
    return 'Good morning';
  }
  if (hour < 18) {
    return 'Good afternoon';
  }
  return 'Good evening';
}

/** First name from a full name, e.g. "Rosina Smith" → "Rosina". Empty string when absent. */
export function firstNameOf(fullName?: string | null): string {
  return (fullName || '').trim().split(/\s+/)[0] || '';
}

/**
 * Personalized greeting line, e.g. "Good morning, Rosina." or "Good morning." when no name.
 * `now` is injectable for tests.
 */
export function personalGreeting(fullName?: string | null, now: Date = new Date()): string {
  const greeting = getTimeOfDayGreeting(now);
  const first = firstNameOf(fullName);
  return first ? `${greeting}, ${first}.` : `${greeting}.`;
}
